import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcesses(producer_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/list_harvest_processes/${producer_id}/fetch_harvest_processes`
    );
  }
}
